import React, { useState } from 'react';
import './Contact.css';

const ContactForm = () => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        try {
            await fetch("https://formsubmit.co/ajax/fullfifax14@gmail.com", {
                method: "POST",
                headers: {
                    'Accept': 'application/json'
                },
                body: formData
            });

            form.reset();
            setShowSuccessModal(true);

            setTimeout(() => {
                setShowSuccessModal(false);
            }, 4000);

        } catch (error) {
            console.error("Form submission error:", error);
        }
    };

    return (
        <div className="contact-section" id="contacts">
            <div className="contact-card">
                <h2>
                    <strong>Contact Me</strong>
                </h2>

                <form onSubmit={handleSubmit} className="contact-form">
                    <input type="text" name="_honey" style={{ display: 'none' }} />
                    <input type="hidden" name="_captcha" value="false" />

                    <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        required
                    />
                    <textarea
                        name="message"
                        placeholder="Your Message"
                        required
                    />
                    <button type="submit">Send Message</button>
                </form>
            </div>

            {showSuccessModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <button className="modal-close" onClick={() => setShowSuccessModal(false)}>×</button>
                        <h3>🎉 Message Sent!</h3>
                        <p>Thank you for reaching out. I’ll get back to you soon!</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContactForm;